import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyles from './css/Nebulisation.module.css';
import { Wind, Send } from 'lucide-react';
import Dropdown from '../../../../components/Dropdown';

const Nebulisation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Treatment details states
    const [medicationUsed, setMedicationUsed] = useState('');
    const [duration, setDuration] = useState('');
    const [oxygenUsed, setOxygenUsed] = useState(false);
    const [response, setResponse] = useState('');

    // Other states
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                nebulisation: {
                    medicationUsed,
                    duration,
                    oxygenUsed,
                    response,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Wind />
                        </div>
                        <h1 className={newStyles.title}>Nebulisation</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>TREATMENT DETAILS</div>
                        <div className={newStyles.readingsRow1}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Medication Used</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="text"
                                        value={medicationUsed}
                                        onChange={(e) => setMedicationUsed(e.target.value)}
                                        className={newStyles.readingInput}
                                        placeholder='e.g., Salbutamol 5mg'
                                    />
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Duration</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                        className={newStyles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>min</span>
                                </div>
                            </div>
                        </div>

                        <div className={newStyles.toggleSection}>
                            <label className={styles.toggleLabel}>Oxygen Used</label>
                            <button
                                type="button"
                                className={`${styles.toggleButton} ${oxygenUsed ? styles.active : ''}`}
                                onClick={() => setOxygenUsed(!oxygenUsed)}
                                aria-pressed={oxygenUsed}
                            >
                                <div className={styles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>RESPONSE TO TREATMENT</div>
                        <div className={newStyles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Response</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="response"
                                        value={response}
                                        onChange={setResponse}
                                        options={['Improved', 'No Change', 'Worsened']}
                                        placeholder="Select..."
                                        className={newStyles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Nebulisation;